<template>
    <div class="table">
        <!-- <el-select v-model="addForm.subjectId" clearable  @change="changeSubjectInAdd">
            <el-option  v-for="item in subjectList"  :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-autocomplete v-model="test" :fetch-suggestions="querySearch"></el-autocomplete> -->
        <div class="container">
            <!-- <div>User {{ $route.params.subjectId }}</div> -->
            <div class="handle-box">
                <el-row :gutter="10" style="margin-bottom:10px">
                <!-- <el-button type="danger" icon="el-icon-delete" class="handle-del mr10" @click="delAll">批量删除</el-button> -->
                    <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="4">
                        <span class="label">科&emsp;&emsp;目</span>
                        <el-select size="mini" v-model="searchParam.subjectId" clearable placeholder="科目" @change="changeSubject">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="4">
                        <span class="label">章&emsp;&emsp;节</span>
                        <el-select size="mini" v-model="searchParam.domain" clearable placeholder="章节" @change="getData()">
                            <el-option v-for="item in domainList" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addVisible = true">添加</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" ref="multipleTable" :max-height="tableLen" @selection-change="handleSelectionChange">
                <!-- <el-table-column type="selection"></el-table-column> -->
                <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
                <el-table-column prop="questionId" label="ID" width="50" align="center"></el-table-column>
                <el-table-column prop="content" label="问题"></el-table-column>
                <el-table-column prop="extractTimes" label="抽取次数" width="100" align="center"></el-table-column>
                <el-table-column prop="correctRate" label="正确率" width="100" align="center"  :formatter="rateFormat"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" @click="deleteQuestion(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
        </div>

        <!-- 单个添加框 -->
        <el-dialog title="添加" :visible.sync="addVisible" width="75%" @closed="clearValidate('addForm')">

            <el-form ref="addForm" :model="addForm" label-width="100px">
                <el-form-item label="科目" prop="subjectId">
                    <el-select v-model="addForm.subjectId" clearable style="width:100%" @change="changeSubjectInAdd">
                        <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="章节" prop="domain">
                    <el-autocomplete v-model="addForm.domain" class="inline-input autocomplete" :fetch-suggestions="querySearch"></el-autocomplete>
                </el-form-item>
                <el-form-item label="问题" prop="content">
                    <el-input v-model="addForm.content"></el-input>
                </el-form-item>
                <el-form-item label="英文" prop="enContent">
                    <el-input v-model="addForm.enContent"></el-input>
                </el-form-item>
                <!-- //TODO 考虑用自定义组件实现 -->
                <el-form-item v-for="(answer, index) in addForm.answerList" :label="'答案' + String.fromCharCode((65+index))" :key="answer.key">
                    <span>
                        <el-input v-model="answer.content" class="answer-input" placeholder="请输入中文"></el-input>
                        <el-input v-model="answer.enContent" class="answer-input" placeholder="请输入英文"></el-input>
                    </span>
                    <el-switch v-model="answer.flag"  :active-value=1 :inactive-value=0  active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-button @click.prevent="rmAnswerInAddForm(index)">删除</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addAnswerInAddForm">添加答案选项</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="75%" @closed="clearValidate('editForm')">
            <el-form ref="editForm" :model="editForm" label-width="100px">
                <el-form-item label="科目" prop="subjectId">
                    <el-select v-model="editForm.subjectId" clearable style="width:100%" @change="changeSubjectInEdit">
                        <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="章节" prop="domain">
                    <el-autocomplete v-model="editForm.domain" class="inline-input autocomplete" :fetch-suggestions="querySearchInEdit"></el-autocomplete>
                </el-form-item>
                <el-form-item label="问题" prop="content">
                    <el-input v-model="editForm.content"></el-input>
                </el-form-item>
                <el-form-item label="英文" prop="enContent">
                    <el-input v-model="editForm.enContent"></el-input>
                </el-form-item>
                <!-- //TODO 考虑用自定义组件实现 -->
                <el-form-item v-for="(answer, index) in editForm.answerList" :label="'答案' + String.fromCharCode((65+index))" :key="answer.key">
                    <span>
                        <el-input v-model="answer.content" class="answer-input" placeholder="请输入中文"></el-input>
                        <el-input v-model="answer.enContent" class="answer-input" placeholder="请输入英文"></el-input>
                    </span>
                    <el-switch v-model="answer.flag"  :active-value=1 :inactive-value=0  active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    <el-button @click.prevent="rmAnswerInEditForm(index)">删除</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addAnswerInEditForm">添加答案选项</el-button>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 单个授权框 -->
        <el-dialog title="设置比例" :visible.sync="editFrequencyVisible" width="400px" @closed="closeFrequencyForm">
            <el-table :data="frequencyForm" stripe style="width: 100%">
                <el-table-column prop="subject.name" label="科目"></el-table-column>
                <el-table-column prop="name" label="次数">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.chance" :min="0"></el-input-number>
                        <!-- <el-button
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editFrequencyVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveFrequency">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "question",
    data() {
        return {
            searchParam: {
                pageNum: 1,
                pageSize: 10
            },
            tableLen:350,
            totalNumber: 0,
            tableData: [], //列表中的数据
            multipleSelection: [],
            subjectList: [],
            domainList: [],
            domainListInAdd: [],
            domainListInEdit: [],
            addVisible: false,
            addBatchVisible: false,
            editVisible: false,
            editFrequencyVisible: false,
            addForm: {
                domain: "",
                answerList: [{content: "", flag: 0,key:Date.now() }]
            },
            editForm: {},
            frequencyForm: [],
            uploadInstance: null,
            test: ""
        };
    },
    created() {
        this.getSubjectList();
        this.getData();
    },
    updated() {
        this.tableLen=window.innerHeight-135;
    },
    methods: {
        async getData() {
            let param = this.$ObjectUtil.cloneObj(this.searchParam);
            param.domain == "" && delete param.domain;
            let res = await this.$axios.post(
                "/manage/question/selectByPage",
                param
            );
            if (res.code == 200) {
                this.tableData = res.data.list;
                this.totalNumber = res.data.total;
            } else {
                this.$message.error(res.errMsg);
            }
        },
        async saveAdd() {
            if (this.addForm.answerList.length < 2) {
                this.$message.error("答案选项至少有两项");
                return;
            }
            
            let answerList = this.addForm.answerList.map((answer,index) => {
                answer.label = String.fromCharCode((65+index));
                return answer;
            });
            this.addForm.answerList = answerList;

            console.log(this.addForm);
            // let valid = await this.$refs.addForm.validate().catch(err => {
            //     return Promise.resolve(false);
            // });
            // if (!valid) {
            //     return;
            // }
            let res = await this.$axios.post(
                "/manage/question/insert",
                this.addForm
            );
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }

            this.$refs.addForm.resetFields();
            this.addVisible = false;
            this.$message.success("保存成功");
            this.$set(this.addForm, 'answerList', []);
            this.getData();
        },
        async edit(index, row) {
            console.log(row.questionId);
            let res = await this.$axios.get(`/manage/question/selectWithAnswerById/${row.questionId}`);
            if (res.code != 200) {
                this.$message.error("获取数据失败");
                return;
            }
            this.editForm = res.data;
            let list = await this.getDomainList(row.subjectId);
            this.domainListInEdit = list;
            this.editVisible = true;
        },
        // 保存编辑
        async saveEdit() {
            console.log(this.editForm);
            // let valid = await this.$refs.editForm.validate().catch(err => {
            //     return Promise.resolve(false);
            // });
            // if (!valid) {
            //     return;
            // }

            let res = await this.$axios.post(
                "/manage/question/update",
                this.editForm
            );
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }

            // TODO 使用自定义组件再变成自动清除
            // this.$refs.editForm = { domain: "", answerList: [{content: "", flag: 0,key:Date.now() }] },
            this.editVisible = false;
            this.$message.success("保存成功");
            this.getData();
            this.changeSubject(this.searchParam.subjectId);
        },
        async deleteQuestion(index, row) {
            let confirm = await this.$confirm('此操作将永久删除该试题，是否继续？',{type:'warning'}).catch(err=>{return Promise.resolve(false)});
            if (!confirm) {
                return;
            }

            let res = await this.$axios.get(`/manage/question/delete/${row.questionId}`);
            if (res.code == 200) {
                this.$message.success("删除成功");
                this.getData();
            } else {
                this.$message.error(res.errMsg);
            }
        },
        async editFrequency(index, row) {
            let res = await this.$axios.get(
                `/manage/frequency/selectByUserId/${row.id}`
            );
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }

            this.frequencyForm = res.data;
            this.editFrequencyVisible = true;
        },
        async saveFrequency() {
            console.log(this.frequencyForm);
            let data = this.frequencyForm.map(obj => {
                for (let key in obj) {
                    if (
                        key !== "chance" &&
                        key !== "userId" &&
                        key !== "subjectId"
                    ) {
                        obj[key] = null;
                    }
                }
                return obj;
            });
            let res = await this.$axios.post(
                "/manage/frequency/updateBatch",
                this.frequencyForm
            );
            if (res.code != 200) {
                this.$message.error(res.errMsg);
                return;
            }
            this.$message.success("保存成功");
            this.editFrequencyVisible = false;
        },
        closeFrequencyForm() {
            this.frequencyForm = [];
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        clearValidate(form) {
            console.log(form);
            console.log(this.$refs[form]);
            this.$refs[form].clearValidate();
        },
        beforeUpload(file) {
            let validate = false;
            if (file && file.name) {
                let name = file.name;
                let ext = name.substring(name.lastIndexOf(".")+1, name.length);
                if (ext == "xls" || ext == "xlsx") {
                    validate = true;
                }
            }
            if (!validate) {
                this.$message.error("只能上传'.xls'或者'.xlsx'文件");
                return;
            }

            if (file.size / 1024 / 1024 > 2) {
                this.$message.error("只能上传小于2M的文件");
            }
            console.log(file);
            this.uploadInstance = this.$loading({
                lock: true,
                text: "上传处理中……",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        uploadSuccess() {
            this.uploadInstance.close();
            this.$message.success("上传处理成功");
        },
        uploadError() {
            this.uploadInstance.close();
            this.$message.error("上传处理失败");
        },
        async changeSubject(subjectId = '') {
            subjectId == "" && (this.domainList = []);
            this.searchParam.domain = "";
            this.getData();
            let list = await this.getDomainList(subjectId);
            this.domainList = list;
        },
        async changeSubjectInAdd(subjectId) {
            subjectId == "" && (this.domainListInAdd = []);
            let temp = this.addForm.domain;
            this.addForm.domain = "";
            let list = await this.getDomainList(subjectId);
            this.domainListInAdd = list;
            for (let d of list) {
                if (d == temp) {
                    this.addForm.domain = temp;
                    break;
                }
            }
        },
        async changeSubjectInEdit(subjectId) {
            subjectId == "" && (this.domainListInEdit = []);
            let temp = this.editForm.domain;
            this.editForm.domain = "";
            let list = await this.getDomainList(subjectId);
            this.domainListInEdit = list;
            for (let d of list) {
                if (d == temp) {
                    this.editForm.domain = temp;
                    break;
                }
            }
        },
        async getDomainList(subjectId) {
            if (subjectId == "") {
                return [];
            }
            let res = await this.$axios.get(
                `/manage/question/selectDomainBySubjectId/${subjectId}`
            );
            if (res.code != 200) {
                this.$message.error("加载章节失败");
            }
            return res.data;
        },
        async getSubjectList() {
            let res = await this.$axios.get("/manage/subject/selectAll");
            if (res.code == 200) {
                this.subjectList = res.data;
            }
        },
        querySearch(queryString, cb) {
            let result;
            if (queryString) {
                result = this.domainListInAdd.filter(domain => {
                    return domain.includes(queryString);
                });
            } else {
                result = this.domainListInAdd;
            }
            result = result.map(domain => {
                return { value: domain };
            });
            cb(result);
        },
        querySearchInEdit(queryString, cb) {
            let result;
            if (queryString) {
                result = this.domainListInEdit.filter(domain => {
                    return domain.includes(queryString);
                });
            } else {
                result = this.domainListInEdit
            }
            result = result.map(domain => {
                return { value: domain };
            });
            cb(result);
        },
        addAnswerInAddForm() {
            this.addForm.answerList.push({content:'', flag:0,key:Date.now()});
        },
        rmAnswerInAddForm(index) {
            this.addForm.answerList.splice(index, 1)
        },
        addAnswerInEditForm() {
            this.editForm.answerList.push({content:'', flag:0,key:Date.now()});
        },
        async rmAnswerInEditForm(index) {
            let confirm = await this.$confirm('确定删除该选项？',{type:'warning'}).catch(err=>{return Promise.resolve(false)});
            if (!confirm) {
                return;
            }

            this.editForm.answerList.splice(index, 1)
        },
        rateFormat(row, column, rate) {
            if (rate !== null) {
                return rate + "%";
            } else {
                return;
            }
        },

    },
    beforeRouteUpdate(to, from, next) {
        this.searchParam.pageSize = 10;
        this.searchParam.pageNum = 1;
        this.searchParam.subjectId = to.params.subjectId;
        this.searchParam.state = "1";
        // this.$set(this.searchParam, 'state', '1');
        console.log("to", to);
        console.log("from", from);
        console.log(this.searchParam);
        next();
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

/* .handle-input {
    width: 200px;
    display: inline-block;
} */
.del-dialog-cnt {
    font-size: 16px;
    text-align: center;
}
.action {
    display: inline;
    /* float: left; */
}
.action:first-child {
    margin-right: 5px;
}

.autocomplete {
    width: 100%;
}

.answer-input{
    width:80%;
}
</style>